import * as React from 'react'

import { Box, List, Skeleton } from '@factorialco/deprecated-design-system'

export const CalendarSyncsListSkeleton = () => {
  return (
    <List>
      <List.Item>
        <List.Title>
          <Box flexDirection="row" alignItems="center" gap="s16">
            <Skeleton width="s32" height="s32" />
            <Skeleton width="s120" height="s12" />
          </Box>
        </List.Title>
        <List.ActionItem>
          <Box flexDirection="row" alignItems="center" gap="s16">
            <Skeleton width="s80" height="s16" />
            <Skeleton width="s32" height="s32" />
          </Box>
        </List.ActionItem>
      </List.Item>
      <List.Item>
        <List.Title>
          <Box flexDirection="row" alignItems="center" gap="s16">
            <Skeleton width="s32" height="s32" />
            <Skeleton width="s96" height="s12" />
          </Box>
        </List.Title>
        <List.ActionItem>
          <Box flexDirection="row" alignItems="center" gap="s16">
            <Skeleton width="s64" height="s16" />
            <Skeleton width="s32" height="s32" />
          </Box>
        </List.ActionItem>
      </List.Item>
      <List.Item>
        <List.Title>
          <Box flexDirection="row" alignItems="center" gap="s16">
            <Skeleton width="s32" height="s32" />
            <Skeleton width="s120" height="s12" />
          </Box>
        </List.Title>
        <List.ActionItem>
          <Box flexDirection="row" alignItems="center" gap="s16">
            <Skeleton width="s80" height="s16" />
            <Skeleton width="s32" height="s32" />
          </Box>
        </List.ActionItem>
      </List.Item>
    </List>
  )
}
